//#region lib/components/CropDialog/softcrop-lib.ts
var e = (e, t, n, r, i) => {
	let a = e.x - t.left, o = e.y - t.top, s = (a - r.x) / n, c = (o - r.y) / n, l = s / i.width, u = c / i.height;
	return l >= 0 && l <= 1 && u >= 0 && u <= 1 ? {
		x: l,
		y: u
	} : null;
}, t = (e, t, n, r) => ({
	x: n.x + e.x * r.width * t,
	y: n.y + e.y * r.height * t
}), n = (e, t, n = 40) => {
	let r = n / 2;
	return {
		x: Math.max(r, Math.min(t.width - r, e.x)),
		y: Math.max(r, Math.min(t.height - r, e.y))
	};
}, r = (e, t, n, r) => {
	let i = (e.x - n.x) / t, a = (e.y - n.y) / t;
	return {
		x: i / r.width,
		y: a / r.height
	};
}, i = (e, t = .02) => {
	let n = e > 0 ? -1 : 1;
	return (1 + t) ** +n;
}, a = (e) => e ? (() => {
	let t = e.split(" ").map(parseFloat);
	return t.length === 4 ? {
		x: t[0],
		y: t[1],
		w: t[2],
		h: t[3]
	} : null;
})() : null, o = (e) => e ? (() => {
	let t = e.split(" ").map(parseFloat);
	return t.length === 2 ? {
		x: t[0],
		y: t[1]
	} : null;
})() : null, s = (e, t) => {
	let n = e.width / e.height, r = e.width * t.w / (e.height * t.h), i = { ...t }, a = {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0
	};
	if (Math.abs(r - n) < .001) return {
		baseCrop: t,
		dragOffsets: a
	};
	if (r > n) {
		let r = t.w * e.width / n, o = r / e.height, s = e.height / r, c = (o - i.h) * s;
		i.h = o;
		let l = i.y + i.h - 1;
		l > 0 ? (a.top = l * s, a.bottom = c - l * s, i.y -= l) : a.bottom = c;
	} else {
		let r = t.h * e.height * n, o = r / e.width, s = e.width / r, c = (o - i.w) * s;
		i.w = o;
		let l = i.x + i.w - 1;
		l > 0 ? (a.left = l * s, a.right = c - l * s, i.x -= l) : a.right = c;
	}
	return {
		baseCrop: i,
		dragOffsets: a
	};
};
//#endregion
export { t as calculateFocusPointScreenPosition, e as clickToFocusPoint, n as constrainFocusPointToVisibleArea, s as decomposeCropArea, a as parseCropString, o as parseFocusString, r as updateConstrainedFocusPoint, i as wheelEventToZoomFactor };
